import { Injectable } from '@angular/core';

import {
    Combine,
    RecordRestrictions,
    Restriction,
    sessionStorageHelper,
    ZoneRestrictions
} from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export class PortalZoneRestrictions extends ZoneRestrictions {
    public regularRecordTypesZone(): Restriction {
        const regularZone: Restriction = super.regularRecordTypesZone();
        if (sessionStorageHelper.has('shareToken')) {
            return regularZone;
        }
        return Combine.And(RecordRestrictions.publishedStatusRestriction(), regularZone);
    }
}
